import { Fingerprint, Link2, ShieldCheck } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

const features = [
  'solution.item.hash',
  'solution.item.description',
  'solution.item.signatures',
  'solution.item.time',
  'solution.item.package',
  'solution.item.link',
  'solution.item.server',
];

export function SolutionSection() {
  const { t } = useI18n();

  return (
    <section className="section split-section">
      <div>
        <p className="eyebrow">{t('solution.eyebrow')}</p>
        <h2>{t('solution.title')}</h2>
        <p>{t('solution.text')}</p>
        <p className="section-note">{t('solution.simple')}</p>
      </div>
      <div className="evidence-panel">
        <div className="evidence-row">
          <Fingerprint size={22} />
          <span>{t('solution.panel.hash')}</span>
        </div>
        <div className="evidence-row">
          <ShieldCheck size={22} />
          <span>{t('solution.panel.signed')}</span>
        </div>
        <div className="evidence-row">
          <Link2 size={22} />
          <span>{t('solution.panel.public')}</span>
        </div>
        <ul>
          {features.map((item) => (
            <li key={item}>{t(item)}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
